import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock, createSlots as _createSlots, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a99df156"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "product-actions align-items-lg-start flex-lg-row ml-lg-0" }
const _hoisted_2 = { class: "d-flex align-items-center" }
const _hoisted_3 = {
  key: 0,
  class: "flex-1"
}
const _hoisted_4 = { key: 1 }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-spin pi-spinner" }, null, -1))
const _hoisted_6 = [
  _hoisted_5
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_ColumnProductName = _resolveComponent("ColumnProductName")!
  const _component_Column = _resolveComponent("Column")!
  const _component_ColumnProductInfo = _resolveComponent("ColumnProductInfo")!
  const _component_ColumnAmount = _resolveComponent("ColumnAmount")!
  const _component_PriceSummary = _resolveComponent("PriceSummary")!
  const _component_DataTable = _resolveComponent("DataTable")!

  return (_openBlock(), _createBlock(_component_DataTable, {
    breakpoint: "1150px",
    "data-key": "id",
    "responsive-layout": "stack",
    value: _ctx.editingCartLines
  }, _createSlots({
    default: _withCtx(() => [
      _createVNode(_component_Column, {
        field: "productName",
        header: _ctx.isSmallScreen ? '' : _ctx.$t('cart.table.colName'),
        style: _normalizeStyle(_ctx.showProductInfoColumn ? { width: '20%' } : {})
      }, {
        body: _withCtx((item) => [
          _createVNode(_component_ColumnProductName, {
            item: item.data
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                (_ctx.canChangeConfiguration(item.data) && item.data.url)
                  ? (_openBlock(), _createBlock(_component_Button, {
                      key: 0,
                      class: "p-button-secondary p-button-text flex-shrink-0 hidden-print px-0 mr-lg-1",
                      icon: "pi pi-cog",
                      label: _ctx.$t('cart.button.editConfiguration'),
                      title: _ctx.$t('cart.button.editConfiguration'),
                      onClick: ($event: any) => {
								_ctx.openUrl(`${item.data.url}?lineitemid=${item.data.id}`);
								$event.target.disabled = true;
							}
                    }, null, 8, ["label", "title", "onClick"]))
                  : _createCommentVNode("", true),
                (_ctx.canRemoveItem(item.data))
                  ? (_openBlock(), _createBlock(_component_Button, {
                      key: 1,
                      class: "p-button-secondary p-button-text flex-shrink-0 hidden-print px-0 mr-2 mr-lg-0",
                      icon: "pi pi-times",
                      label: _ctx.$t('cart.button.removeItem'),
                      title: _ctx.$t('cart.button.removeItem'),
                      onClick: ($event: any) => (_ctx.confirmRemoveItem(item.data))
                    }, null, 8, ["label", "title", "onClick"]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 2
          }, 1032, ["item"])
        ]),
        _: 1
      }, 8, ["header", "style"]),
      (_ctx.showProductInfoColumn)
        ? (_openBlock(), _createBlock(_component_Column, { key: 0 }, {
            body: _withCtx((item) => [
              _createVNode(_component_ColumnProductInfo, {
                item: item.data
              }, null, 8, ["item"])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.showSerialNumberColumn)
        ? (_openBlock(), _createBlock(_component_Column, {
            key: "serialNumber",
            field: "serialNumber",
            header: _ctx.$t('cart.table.colSerialNumber'),
            style: {"width":"12.5%"}
          }, null, 8, ["header"]))
        : _createCommentVNode("", true),
      (_ctx.showTrainingTypeColumn)
        ? (_openBlock(), _createBlock(_component_Column, {
            key: "trainingType",
            field: "trainingMethod",
            header: _ctx.$t('cart.table.colType'),
            style: {"width":"12.5%"}
          }, null, 8, ["header"]))
        : _createCommentVNode("", true),
      (_ctx.showAmountColumn)
        ? (_openBlock(), _createBlock(_component_Column, {
            key: "amount",
            class: "flex-wrap",
            field: "amount",
            header: _ctx.$t('cart.table.colAmount'),
            style: {"width":"12.5%"}
          }, {
            body: _withCtx((item) => [
              _createElementVNode("div", _hoisted_2, [
                _createVNode(_component_ColumnAmount, {
                  disabled: _ctx.isSpinnerVisible(item.data.id),
                  editable: _ctx.canAdjustAmount(item.data),
                  item: item.data,
                  onAmountChanged: ($event: any) => (_ctx.onAmountChanged($event, item.index))
                }, null, 8, ["disabled", "editable", "item", "onAmountChanged"])
              ])
            ]),
            _: 1
          }, 8, ["header"]))
        : _createCommentVNode("", true),
      _createVNode(_component_Column, {
        header: _ctx.isSmallScreen ? '' : _ctx.$t('cart.table.colPrice'),
        style: {"width":"25%"}
      }, {
        body: _withCtx((item) => [
          (!_ctx.isSpinnerVisible(item.data.id))
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createVNode(_component_PriceSummary, {
                  vm: _ctx.getPriceSummary(item.data)
                }, null, 8, ["vm"])
              ]))
            : (_ctx.isSpinnerVisible(item.data.id))
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_6))
              : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["header"])
    ]),
    _: 2
  }, [
    (_ctx.tableTitle)
      ? {
          name: "header",
          fn: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.tableTitle), 1)
          ]),
          key: "0"
        }
      : undefined
  ]), 1032, ["value"]))
}